<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-1">
      <div class="home-text">
        <div>Illuminate Your Brand, Create Happy Success</div>
        <p>Welcome to the official website of Hami-Happy Advertising Agency! We are dedicated to providing innovative advertising solutions for your brand, empowering your business to thrive. Whether you're a small startup or a renowned enterprise, we can help you establish a captivating brand image in the Indonesian market, leading the trends. With our wealth of experience and professional team, we tailor personalized advertising strategies to help you win more customers and market share. Let's join hands and create a brighter future together!</p>
        <div class="btn-text">Get in Touch</div>
      </div>
    </div>

    <div class="home-2">
      <div class="title">We are offering you <br> with the best service</div>
      <div class="list-box">
        <div class="item">
          <img src="../assets/home-2.png" alt="">
          <div>Creative Advertising Strategy: </div>
          <p>Our professional team collaborates with you to provide innovative advertising strategies and concepts, ensuring your brand stands out in the market.</p>
          <div class="mors">Read More</div>
        </div>
        <div class="item">
          <img src="../assets/home-3.png" alt="">
          <div>Multi-channel Advertising Deployment: </div>
          <p>We leverage various advertising channels including social media, television, radio, and print media to maximize your brand exposure and influence.</p>
          <div class="mors">Read More</div>
        </div>
        <div class="item">
          <img src="../assets/home-4.png" alt="">
          <div>Data-Driven Optimization: </div>
          <p>We continuously monitor and analyze advertising performance data, making adjustments and optimizations based on feedback to ensure your advertising investment yields the maximum return.</p>
          <div class="mors">Read More</div>
        </div>
      </div>
    </div>

    <div class="home-3-box">
      <div class="home-3">
        <!-- <div class="sbtitle">4561456</div> -->
        <div class="title">Tailored Comprehensive Advertising Solutions</div>
      </div>
      <div class="best-box">
        <div class="serve">
          <div><img src="../assets/home-5.png" alt="">Innovative Strategy Design</div>
          <div><img src="../assets/home-6.png" alt="">Multi-channel Media Placement</div>
          <div><img src="../assets/home-7.png" alt="">Precise Data Analysis</div>
          <div><img src="../assets/home-8.png" alt="">Professional Client Services</div>
        </div>
        <div class="best-list">
          <img src="../assets/home-9.png" alt="">
          <div class="best-text">
            <p><img src="../assets/home-10.png" alt="">From concept to execution, we provide comprehensive advertising solutions for you.</p>
            <p><img src="../assets/home-10.png" alt="">Leverage our professional team and advanced technology to make your brand stand out in the market.</p>
            <p><img src="../assets/home-10.png" alt="">Whether your goal is to increase brand awareness or boost sales, we will tailor the best solution to achieve your objectives.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="home-4">
      <!-- <div class="sbtitle">4561456</div> -->
      <div class="title">Unlocking Infinite Possibilities <br> for Your Brand</div>
      <div class="img-list">
        <div class="img-box">
          <img src="../assets/home-11.png" alt="">
          <div class="text-box">
            <div>Brand Strategy Positioning</div>
            <p>Collaborate with you to develop effective brand positioning strategies, helping your brand stand out in the competitive market.</p>
          </div>
        </div>
        <div class="img-box">
          <img src="../assets/home-12.png" alt="">
          <div class="text-box">
            <div>Creative Content Creation</div>
            <p>Craft attention-grabbing advertising content to engage target audiences and enhance brand awareness and loyalty.</p>
          </div>
        </div>
        <div class="img-box">
          <img src="../assets/home-13.png" alt="">
          <div class="text-box">
            <div>Digital Marketing Solutions</div>
            <p>Utilize the latest digital marketing tools and technologies to elevate your brand's visibility and impact in the online world.</p>
          </div>
        </div>
      </div>
    </div>

    <footerBox :step="1"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.home-1 {
  background: url(../assets/home-1.png);
  height: 800px;
  background-size: 100% 100%;

  .home-text {
    padding-top: 160px;
    margin-left: 360px;
    width: 750px;

    div {
      font-weight: bold;
      font-size: 64px;
      color: #FFFFFF;
    }

    p {
      font-weight: 400;
      font-size: 16px;
      color: #B8A4EC;
      margin-top: 30px;
    }

    .btn-text {
      width: 194px;
      height: 68px;
      background: #FFFFFF;
      border-radius: 20px 20px 20px 20px;
      font-weight: 400;
      font-size: 22px;
      color: #1D1628;
      line-height: 68px;
      text-align: center;
      margin-top: 80px;
    }
  }
}

.home-2 {
  padding: 150px 360px;

  .sbtitle {
    font-weight: 500;
    font-size: 24px;
    color: #6434E0;
    text-align: center;
  }

  .title {
    font-weight: bold;
    font-size: 46px;
    color: #333333;
    text-align: center;
    margin-top: 20px;
    // width: 500px;
  }

  .list-box {
    margin-top: 145px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      width: 400px;
      height: 300px;
      background: #FFFFFF;
      box-shadow: 0px 7px 32px 0px rgba(12, 59, 102, 0.15);
      border-radius: 20px 20px 20px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px;

      img {
        width: 110px;
        margin-top: -95px;
      }

      div {
        margin-top: 32px;
        font-weight: 600;
        font-size: 24px;
        color: #333333;
      }

      p {
        margin-top: 13px;
      }

      .mors {
        font-weight: 400;
        font-size: 19px;
        color: #4B516B;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-decoration-line: underline;
        text-transform: none;
      }
    }
  }
}

.home-3-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  .home-3 {
    background-image: url(../assets/home-14.png);
    background-size: 100% 100%;
    height: 610px;
    width: 100%;

    .sbtitle {
      font-weight: 500;
      font-size: 24px;
      color: #6434E0;
      text-align: center;
      padding-top: 161px;
    }

    .title {
      font-weight: bold;
      font-size: 46px;
      color: #333333;
      text-align: center;
      margin-top: 20px;
      // width: 500px;
    }

  }

  .best-box {
    width: 1200px;
    min-height: 464px;
    background: #FFFFFF;
    border-radius: 40px 40px 40px 40px;
    border: 2px solid #D9D9D9;
    margin-top: -200px;
    padding: 50px;
    display: flex;
    justify-content: space-between;

    .serve {
      width: 450px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;


      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 180px;
        background: #F3F2F8;
        border-radius: 30px 30px 30px 30px;
        padding: 30px;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
      }

      img {
        width: 80px;
      }
    }

    .best-list {
      width: 700px;

      img {
        width: 622px;
      }

      .best-text {
        p {
          font-weight: 500;
          font-size: 20px;
          color: #6B6A72;
          display: flex;
          align-items: center;
          margin-top: 20px;

          img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }

        }
      }
    }
  }
}

.home-4 {
  padding: 150px 360px;

  .sbtitle {
    font-weight: 500;
    font-size: 24px;
    color: #6434E0;
    text-align: center;
  }

  .title {
    font-weight: bold;
    font-size: 46px;
    color: #333333;
    text-align: center;
    margin-top: 20px;
    // width: 500px;
  }

  .img-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 80px;

    .img-box {
      width: 385px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 385px;
      }

      .text-box {
        width: 273px;
        min-height: 128px;
        background: #FFFFFF;
        box-shadow: 0px 7px 32px 0px rgba(12, 59, 102, 0.15);
        border-radius: 20px 20px 20px 20px;
        padding: 16px;
        margin-top: -50px;

        div {
          font-weight: 600;
          font-size: 20px;
          color: #333333;
        }

        p {
          font-weight: 400;
          font-size: 16px;
          color: #999999;
        }
      }
    }
  }
}
</style>
